module.exports = __webpack_public_path__ + "9930482e5c05790e9039119d2daf2538.png";